import { Icon, Icons } from 'components/Icon';
import React from 'react';
import { Link } from 'react-router-dom';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { selectAccountDetails } from 'selectors/account-selector';
import { useAppSelector } from 'store/hooks';
import { createMarkup } from 'utils';

export default function WillSummaryPreview() {
  const { user } = useAppSelector(selectAccountDetails);

  return (
    <div>
      <div className="mt-10 space-y-10 rounded-md bg-white px-32 py-20">
        <div className="rounded-lg border-2 border-[#EBEBEB] text-[#626465]">
          <div className="border-b-2 border-[#EBEBEB]">
            <div className="bottom-1 flex items-center justify-between p-8">
              <p className="text-3xl">{user.instructionTitle}</p>
              <Link to="/dashboard/will-summary">
                <Icon name={Icons.Close} />
              </Link>
            </div>
          </div>
          <p className="p-12 text-xs">
            <p
              dangerouslySetInnerHTML={createMarkup(
                user.instructionDescription
              )}
              className="text-[12px] font-[500] text-[#434343]"
            ></p>
          </p>
        </div>
      </div>
    </div>
  );
}
